import { createApp } from 'vue';
import Sticky from 'utils/sticky-directive';
import CommonPlugin from 'plugins/common-plugin';
import { i18n } from 'utils/i18n';
import store from 'stores/formulation-repository';
import FormulationRepository from 'views/formulation-repo/FormulationRepository.vue';

require('styles/pages/formulation-repository.less');

const app = createApp({
  components: { FormulationRepository }
});

app.use(CommonPlugin);
app.use(store);
app.use(i18n);
app.use(Sticky);

app.mount('#app');
